import { useState } from "react";
import TimeLine from "../components/kits/timeline/TimeLine.jsx";
import ColorSchema from "../components/kits/Color";
import {
  TickIcon,
  HomeIcon,
  PhoneIcon1,
  BellIcon
} from "../components/kits/Icons.tsx";
export default function TimeLinePage() {
  const [timeLineItem, setTimeLineItem] = useState([
    {
      Icon: <HomeIcon color={ColorSchema.white_custom} iconClassName="ms-1" />,
      bgColor: ColorSchema.primary_custom,
      children: (
        <div>
          <h3 className="vertical-timeline-element-title">hello1</h3>
          <h5 className="vertical-timeline-element-subtitle">goodbye</h5>
        </div>
      )
    },
    {
      Icon: (
        <PhoneIcon1 color={ColorSchema.white_custom} iconClassName="ms-1" />
      ),
      bgColor: ColorSchema.pink_custom,
      children: (
        <div>
          <h3>hello2</h3>
          <h5>goodbye</h5>
        </div>
      )
    },
    {
      Icon: <BellIcon color={ColorSchema.white_custom} iconClassName="ms-1" />,
      bgColor: ColorSchema.orange_custom,
      children: (
        <div>
          <h3>hello3</h3>
          <h5>goodbye</h5>
        </div>
      )
    },
    {
      Icon: <TickIcon color={ColorSchema.white_custom} iconClassName="ms-1" />,
      bgColor: ColorSchema.success_custom,
      children: (
        <div>
          <h3>hello4</h3>
          <h5>goodbye</h5>
        </div>
      )
    }
  ]);
  return (
    <>
      {timeLineItem.map(value => {
        return (
          <TimeLine
            bgColor={value.bgColor}
            Icon={value.Icon}
            children={value.children}
          ></TimeLine>
        );
      })}
    </>
  );
}
